import { Outlet, NavLink, Link } from "react-router-dom";
import { MessageSquare, ListChecks, Users, HelpCircle, LogOut, KeyRound, LayoutGrid } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuth";

const TABS = [
  { to: "/admin", label: "Чат", key: "chat", icon: MessageSquare, end: true },
  { to: "/admin/tasks", label: "Задачі", key: "tasks", icon: ListChecks, end: false },
  { to: "/admin/subscribers", label: "Абоненти", key: "subscribers", icon: Users, end: false },
];

export default function AdminLayout() {
  const { admin, logout } = useAdminAuth();

  return (
    <div className="h-[100dvh] flex flex-col overflow-hidden bg-slate-50">
      <nav data-testid="admin-topnav" className="h-14 shrink-0 bg-white border-b border-slate-200 flex items-center gap-1 px-3 md:px-5">
        <div className="flex items-center gap-2.5 mr-2 md:mr-5">
          <div className="w-9 h-9 rounded-[10px] bg-[#0F76BC] flex items-center justify-center text-white">
            <LayoutGrid size={18} />
          </div>
          <div className="hidden sm:block leading-tight">
            <div className="font-head font-extrabold text-sm">IPPLUS CRM</div>
            <div className="text-[11px] text-slate-500">Провайдер</div>
          </div>
        </div>

        <div className="flex items-center gap-1">
          {TABS.map((t) => (
            <NavLink
              key={t.key}
              to={t.to}
              end={t.end}
              data-testid={`tab-${t.key}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3.5 md:px-4 py-2 rounded-[10px] text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#0F76BC] text-white" : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <t.icon size={16} />
              <span>{t.label}</span>
            </NavLink>
          ))}
        </div>

        <div className="ml-auto flex items-center gap-2">
          <span className="hidden md:block text-sm text-slate-500">{admin?.name}</span>
          <Link
            to="/admin/help"
            data-testid="nav-help-btn"
            title="Довідка та підключення"
            className="w-9 h-9 rounded-[10px] hover:bg-slate-100 flex items-center justify-center text-slate-500 transition-colors"
          >
            <HelpCircle size={18} />
          </Link>
          <Link
            to="/admin/keys"
            data-testid="nav-keys-btn"
            title="API-ключі та інтеграції"
            className="w-9 h-9 rounded-[10px] hover:bg-slate-100 flex items-center justify-center text-slate-500 transition-colors"
          >
            <KeyRound size={18} />
          </Link>
          <button
            data-testid="logout-btn"
            onClick={logout}
            title="Вийти"
            className="w-9 h-9 rounded-[10px] hover:bg-red-50 hover:text-red-500 flex items-center justify-center text-slate-500 transition-colors"
          >
            <LogOut size={18} />
          </button>
        </div>
      </nav>

      <main className="flex-1 min-h-0">
        <Outlet />
      </main>
    </div>
  );
}
